<template>
  <div class="like-box">
    <canvas ref="thumsCanvas" width="200" height="300" style="width:100px"></canvas>
    <div>
      <slot>
        <div class="like-btn">飘心</div>
      </slot>
    </div>
  </div>
</template>

<script>
  import ThumbsUpAni from './canvas'

  export default {
    name: "Like",
    props: {
      sum: {
        type: Number,
        default: 0
      },
      keepLike: { // 保持一直飘心
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        imgList: [],
        interval: null,
        keepLikeInterval: null,
        likeTimeout: null,
        firstChange: true,
        thumbsUpAni: null
      };
    },
    watch: {
      sum(newVal, oldVal) {
        if (newVal > oldVal) {
          let newLike = newVal - oldVal
          this.init(newLike)
        }
      },
    },
    mounted() {
      this.thumbsUpAni = new ThumbsUpAni(this.$refs.thumsCanvas);
      if (this.keepLike) {
        setInterval(()=>{
          this.thumbsUpAni.start();
        },1000);
      }
    },
    methods: {
      init(newLike) {
        if (this.firstChange) {
          this.firstChange = false
          return
        }
        clearInterval(this.interval)
        let count = newLike >= 5 ? 5 : newLike
        let i = 1
        this.interval = setInterval(() => {
          if (i >= count) {
            clearInterval(this.interval)
          }
          this.like();
          i++
        }, 0);
      },
      handleKeepLike() {
        // 持续点赞出图
        this.keepLikeInterval = setInterval(() => {
          this.like()
        }, 1000)
      },
      like() {
        this.thumbsUpAni.start();
      }
    },
    beforeDestroy() {
      this.keepLikeInterval && clearInterval(this.keepLikeInterval)
      this.interval && clearInterval(this.interval)
    }
  }
</script>

<style lang="scss" scoped>
.like-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
